export const STUDIO_ASSET_PREFIX = 'studio-gouache';

export const isStudioAsset = (assetId: string | null | undefined): assetId is string => {
  return typeof assetId === 'string' && assetId.startsWith(STUDIO_ASSET_PREFIX);
};
